export default {
  ar: {
    title: 'قواعد',
    content:
      '1. سيحتاج المستخدمون إلى وضع رسوم دخول لتشغيل اللعبة.<br/>2. سيتم جمع الكونزات ومكافأتها مرة أخرى لمستخدمينا.<br/>سيتم تحصيل رسوم رمزية ل App.<br/>3. سيتم عرض أفضل الفائزين في اللعبة.<br/>4. لدى App الحق النهائي في هذا النشاط.<br/>آبل ليست راعية ولا تشارك في الحدث بأي شكل من الأشكال.'
  },
  en: {
    title: 'rule',
    content:
      '1. Users will need to place an entry fee for the game to run.<br/>2. Coins will be collected and rewarded back to our users. <br/>A small fee will be taken by App. </br> 3. Top winners will be shown in the game. <br/>4. App has the final right to this activity. <br/>Apple is not a sponsor, nor participate in the event in any form.'
  },
  zh: {
    title: '规则',
    content:
      '1. 用户需要支付入场费才能运行游戏。<br/>2. 代币将被收集并回馈给我们的用户。<br/>App 将收取少量费用。<br/>3. 游戏中将显示最高获胜者。<br/>4、App对此活动拥有最终权利。<br/>Apple 不是赞助商，也不是以任何形式参与此次活动。'
  },
  tr: {
    title: 'kural',
    content:
      "1. Kullanıcıların oyunun çalışması için bir giriş ücreti yatırması gerekecektir.<br/>2. Madeni paralar toplanacak ve kullanıcılarımıza geri verilecektir.<br/>App tarafından küçük bir ücret alınacaktır.<br/>3. En çok kazananlar oyunda gösterilecektir.<br/>4. App'nin bu faaliyet üzerinde son hakkı vardır.<br/>Apple sponsor değildir ve etkinliğe herhangi bir biçimde katılmaz."
  },
  jp: {
    title: 'ルール',
    content:
      '1.ユーザーは、ゲームを実行するための参加費を支払う必要があります。<br/>2.コインが収集され、ユーザーに還元されます。<br/>Appは少額の手数料を負担します。<br/>4. Appは、このアクティビティに対する最終的な権利を持っています。<br/>Appleはスポンサーではなく、いかなる形でもイベントに参加しません'
  },
  pt: {
    title: 'regra',
    content:
      '1. Os usuários precisarão pagar uma taxa de entrada para que o jogo seja executado.<br/>2. Moedas serão coletadas e recompensadas de volta aos nossos usuários. <br/>Uma pequena taxa será cobrada pelo App. </br> 3. Os principais vencedores serão exibidos no jogo. <br/>4. O App tem o direito final sobre esta atividade. <br/>A Apple não é patrocinadora, nem participa do evento de qualquer forma.'
  },
  id: {
    title: 'aturan',
    content:
      '1. Pengguna perlu membayar biaya masuk agar permainan dapat dijalankan.<br/>2. Koin akan dikumpulkan dan diberikan kembali kepada pengguna kami. <br/>Biaya kecil akan diambil oleh Aplikasi. </br> 3. Pemenang teratas akan ditampilkan dalam permainan. <br/>4. Aplikasi memiliki hak final atas aktivitas ini. <br/>Apple bukan sponsor, dan tidak berpartisipasi dalam acara ini dalam bentuk apapun.'
  },
  uz: {
    title: 'qoidalar',
    content:
      "1. O'yin ishlashi uchun foydalanuvchilar kirish to'lovini to'lashlari kerak.<br/>2. Tanga to'planadi va foydalanuvchilarga qaytariladi. <br/>Ilova kichik miqdorda to'lov oladi. </br> 3. Eng yaxshi g'oliblar o'yinda ko'rsatiladi. <br/>4. Ilova ushbu faoliyatda yakuniy huquqqa ega. <br/>Apple homiy emas, shuningdek, tadbirda har qanday shaklda qatnashmaydi."
  },
  ru: {
    title: 'правила',
    content:
      '1. Для запуска игры пользователи должны внести вступительный взнос.<br/>2. Монеты будут собраны и возвращены нашим пользователям. <br/>Небольшая комиссия будет взиматься приложением. </br> 3. Топ победителей будет показан в игре. <br/>4. Приложение имеет окончательное право на это мероприятие. <br/>Apple не является спонсором и не участвует в мероприятии в любой форме.'
  },
  fa: {
    title: 'قوانین',
    content:
      '1. کاربران باید هزینه ورودی برای اجرای بازی را پرداخت کنند.<br/>2. سکه‌ها جمع‌آوری شده و به کاربران بازپرداخت خواهند شد. <br/>یک هزینه کوچک توسط اپلیکیشن دریافت می‌شود. </br> 3. بهترین برندگان در بازی نمایش داده خواهند شد. <br/>4. اپلیکیشن حق نهایی را در این فعالیت دارد. <br/>Apple حامی نیست و در هیچ شکلی در این رویداد شرکت نمی‌کند.'
  }
}



// WEBPACK FOOTER //
// src/pages/app/lottery/lang.js